/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'

import logger from '@/utils/logger'

export default function useInterval(
  callback: () => void,
  intervalMs: number | null,
  // ^ When set to null, effectively cancels the interval
  deps: React.DependencyList,
  {
    immediate = false,
  }: {
    immediate?: boolean
  } = {}
): void {
  React.useEffect(() => {
    if (intervalMs == null) {
      return
    }

    const intervalId = setInterval(callback, intervalMs)

    try {
      if (immediate) {
        callback()
      }
    } catch (err) {
      logger.error('useInterval: callback threw an error', { err })
    }

    // eslint-disable-next-line consistent-return
    return () => {
      clearInterval(intervalId)
    }
  }, [intervalMs, ...deps])
}
